import React, { useState } from 'react';
import {parseCoordinate} from '../../../helpers/parsers.js';
const CoordinateInput = ({label, val, onValueChange}) => {
  return (
    <div className="input-group">
      <span className="input-group-addon input-label-text">
        {label}
      </span>
      <input
        type='number'
        value={val || ""}
        onChange={(e) => onValueChange(e.target.value)}
        className='form-control'
        size='sm'
      />
    </div>
  );
}

const CoordinateCellEditor = ({value, format, onValueChange, eventKey}, ref) => {
    let parsedValue = parseCoordinate({value}) ? parseCoordinate({value}).split(',') : ["",""];
    if (parsedValue.length === 1){
        parsedValue = ["", ""];
    }

    const [lat, setLat] = useState(parsedValue[0]);
    const [lng, setLng] = useState(parsedValue[1]);
    const setLatVal = (val) => {
        setLat(val);
        onValueChange(`${val},${lng}`);
    }

    const setLngVal = (val) => {
        setLng(val);
        onValueChange(`${lat},${val}`);
    }

  return (
    <div className="row" style={{ "min-width": '350px' }}>
      <div className="col-xs-6">
        <CoordinateInput val={lat} onValueChange={setLatVal} label={I18n.t('latitude_short')} />
      </div>
      <div className="col-xs-6">
        <CoordinateInput val={lng} onValueChange={setLngVal} label={I18n.t('longitude_short')} />
      </div>
    </div>
  );
}

export default CoordinateCellEditor;
